import { api } from "../api.js";
import { navigate } from "../app.js";
import { infiniteScroll } from "../infiniteScroll.js";
import { notificationRowHtml, refreshUnreadCount, markAllRead } from "../notifications.js";

/**
 * The whole inbox, paged.
 *
 * The bell's dropdown shows the recent few; this is where you come when
 * you want the rest, or want to work through them.
 */
export function render(container) {
  container.innerHTML = `
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="display-heading h3 mb-0">Notifications</h1>
      <div class="d-flex align-items-center gap-2">
        <div class="form-check form-switch mb-0">
          <input class="form-check-input" type="checkbox" id="unread-only" />
          <label class="form-check-label small" for="unread-only">Unread only</label>
        </div>
        <button class="btn btn-sm btn-outline-secondary" id="read-all-btn">Mark all read</button>
      </div>
    </div>
    <div class="list-group" id="notification-list"></div>`;

  const list = container.querySelector("#notification-list");
  const unreadOnly = container.querySelector("#unread-only");
  let feed = null;

  function load() {
    feed?.destroy();
    feed = infiniteScroll(list, {
      path: "/notifications",
      query: unreadOnly.checked ? { unread: 1 } : {},
      emptyHtml: unreadOnly.checked
        ? `<div class="dc-empty"><i class="bi bi-check2-all"></i><div class="fw-semibold">All caught up</div><div>Nothing unread.</div></div>`
        : `<div class="dc-empty"><i class="bi bi-bell"></i><div class="fw-semibold">Nothing yet</div><div>Follows, reactions, comments and event sign-ups show up here.</div></div>`,
      render: (target, items) => {
        const batch = document.createElement("div");
        batch.innerHTML = items.map((n) => notificationRowHtml(n)).join("");
        batch.querySelectorAll("[data-notification-id]").forEach((row) => {
          row.addEventListener("click", () => open(row));
        });
        target.append(batch);
      },
    });
  }

  /** Reading one and going to it. The row is marked read optimistically:
   *  the navigation is the point, and waiting on a round trip before
   *  moving would make the whole list feel slow. */
  async function open(row) {
    const id = Number(row.dataset.notificationId);
    const wasUnread = row.classList.contains("dc-unread");
    if (wasUnread) row.classList.remove("dc-unread");
    navigate(row.dataset.go);
    if (!wasUnread) return;
    try {
      await api.post(`/notifications/${id}/read`);
    } catch (_) {
      // Left as read locally. The next page load asks the server again.
    }
    refreshUnreadCount();
  }

  unreadOnly.addEventListener("change", load);
  container.querySelector("#read-all-btn").addEventListener("click", async () => {
    await markAllRead();
    load();
  });

  load();
}
